<template>
  <div class="comContent update-box">
    <div class="update-title">
      <div>
        <!-- 业务端APP版本管理 -->
        <MyTabs class="search" :tabi="tabsVal" keyname="val" :tabs="tabsData" @change="tabChange" />
      </div>
      <div>
        <MyButton type="primary" v-if="permissions['sys_app_add']" icon="el-icon-plus" text="新建版本" @click="goAdd" />
      </div>
    </div>
    <div class="update-content">
      <MyTable :table-data="tableData"
        :index="false"
        :selection="false"
        :page="page"
        :operation="false"
        :table-option.sync="tableOption"
        @page-change="getList"
        @handleSelectionChange="currentChange">
        <template slot="type" slot-scope="scope">
          <span>{{ scope.row.type=='ios'?'苹果系统':'安卓系统' }}</span>
        </template>
        <template slot="forceUpdate" slot-scope="scope">
          <span>{{ scope.row.forceUpdate=='1'?'是':'否' }}</span>
        </template>
        <template slot="tools" slot-scope="scope">
          <div style="display:flex">
            <el-link type="primary" v-if="permissions['sys_app_del']" :underline="false" size="small" @click="goDel(scope.row)">删除</el-link>
          </div>
        </template>
      </MyTable>
    </div>
    <UpdateDialog ref="dialogRef" :appName="tabsVal" @submit="initData"></UpdateDialog>
  </div>
</template>

<script>
import MyButton from '@/components/myButton';
import MyTable from '@/components/myTable';
import UpdateDialog from './components/updateDialog.vue';
import MyTabs from '@/components/myTabs'
import { mapGetters } from "vuex";
import { appVersionList, appVersionDel } from '@/api/apk'

export default {
  components: { MyButton, MyTable, UpdateDialog, MyTabs },
  data () {
    return {
      tabsData: [
        { name: '业务端APP', num: 0, val: 'salesman', numhide: true },
        { name: '药潺潺APP', num: 0, val: 'wholesale', numhide: true }, // 业务端：salesman，药潺潺：wholesale
      ],
      tabsVal: 'salesman',
      tableData: [],
      tableOption: [
        { label: '版本号', prop: 'version', width: '90px' },
        { label: '系统类型', slot: true, prop: 'type', width: '90px' },
        { label: '更新描述', prop: 'remark' },
        { label: '是否强更', prop: 'forceUpdate', slot: true, width: '120px' },
        { label: '更新时间', prop: 'createTime', width: '180px' },
        { label: '操作', prop: 'tools', slot: true, width: '80px' }
      ],
      page: { total: 10, current: 1, size: 10 },
      addDialogVisible: false,
    }
  },
  computed:{
    ...mapGetters(["permissions"]),
  },
  created () {
    this.initData();
  },
  mounted () { },
  methods: {
    tabChange (val) {
      this.tabsVal = val;
      this.initData();
      // this.page.current = 1
      // this.getcheckList()
    },
    goDel(el){
      this.$confirm('是否确认删除此版本记录?', '提醒', { type: 'warning' }).then(() => {
        appVersionDel(el.id).then(res=>{
          this.initData()
          this.$notify.success('删除成功')
        })
      }).catch(()=>{
        console.log('用户取消删除操作')
      })
    },
    goAdd(){
      let dRef = this.$refs.dialogRef;
      if(dRef){
        dRef.openDialog();
      }
    },
    initData(){
      this.page.current = 1;
      this.getList()
    },
    getList () {
      const { current, size } = this.page
      let data = { current, size, appName: this.tabsVal}
      // console.log(data)
      appVersionList(data).then((res) => {
        // console.log('list',res)
        const { records, total } = res.data;
        this.tableData = records;
        this.page.total = total;
      }).catch(() => { })
    },
    currentChange (val) {
      // console.log('current', val)
    },
  }
}
</script>
<style lang='scss' scoped>
.update{
  &-box{
    padding: 0px;
  }
  &-title{
    height: 56px;
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f5f5ff;
  }
  &-content{
    margin: 0 24px;
    margin-top: 16px;
    height: calc(100% - 131px);
  }
}
</style>
